//authentication
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";
export const LOAD_CURRENT_USER_DETAIL="LOAD_CURRENT_USER_DETAIL";


//employees
export const GET_EMPLOYEES_START="GET_EMPLOYEES_START";
export const GET_EMPLOYEES_SUCCESS="GET_EMPLOYEES_SUCCESS";
export const GET_EMPLOYEES_FAIL="GET_EMPLOYEES_FAIL";
export const CREATE_EMPLOYEE_START="CREATE_EMPLOYEE";
export const CREATE_EMPLOYEE_SUCCESS="CREATE_EMPLOYEE_SUCCESS";
export const CREATE_EMPLOYEE_FAIL="CREATE_EMPLOYEE_FAIL";
export const UPDATE_EMPLOYEE_START="UPDATE_EMPLOYEE_START";
export const UPDATE_EMPLOYEE_SUCCESS="UPDATE_EMPLOYEE_SUCCESS";
export const UPDATE_EMPLOYEE_FAIL="UPDATE_EMPLOYEE_FAIL";


//edit edit user form
export const OPEN_EDIT_FORM="OPEN_EDIT_FORM";
export const CLOSE_EDIT_FORM="CLOSE_EDIT_FORM";
export const CLEAR_EDIT="CLEAR_EDIT";

//clear data when logout

export const CLEAR_DATA="CLEAR_DATA";

// password
export const RESET_PASSWORD_START="RESET_PASSWORD_START";
export const RESET_PASSWORD_SUCCESS="RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL="RESET_PASSWORD_FAIL";
export const CLEAR_RESET="CLEAR_RESET";
export const OPEN_RESET_FORM="OPEN_RESET_FORM";
export const CLOSE_RESET_FORM="CLOSE_RESET_FORM";

//roles
export const GET_ROLE_START="GET_ROLE_START";
export const GET_ROLE_SUCCESS="GET_ROLE_SUCCESS";
export const GET_ROLE_FAIL="GET_ROLE_FAIL";

//products

export const GET_PRODUCT_START="GET_PRODUCT_START";
export const GET_PRODUCT_SUCCESS="GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAIL="GET_PRODUCT_FAIL";

export const CREATE_PRODUCT_START="CREATE_PRODUCT_START";
export const CREATE_PRODUCT_SUCCESS="CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAIL="CREATE_PRODUCT_FAIL";

export const UPDATE_PRODUCT_START="UPDATE_PRODUCT_START";
export const UPDATE_PRODUCT_SUCCESS="UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAIL="UPDATE_PRODUCT_FAIL";

export const OPEN_PRODUCT_EDIT_FORM="OPEN_PRODUCT_EDIT_FORM";
export const CLOSE_PRODUCT_EDIT_FORM="CLOSE_PRODUCT_EDIT_FORM";

export const CLEAR_PRODUCT_EDIT="CLEAR_PRODUCT_EDIT";

export const DELETE_PRODUCT_START="DELETE_PRODUCT_START";
export const DELETE_PRODUCT_SUCCESS="DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAIL="DELETE_PRODUCT_FAIL";

//agents
export const GET_AGENTS_START="GET_AGENTS_START";
export const GET_AGENTS_SUCCESS="GET_AGENTS_SUCCESS";
export const GET_AGENTS_FAIL="GET_AGENTS_FAIL";

export const CREATE_AGENT_START="CREATE_AGENT_START";
export const CREATE_AGENT_SUCCESS="CREATE_AGENT_SUCCESS";
export const CREATE_AGENT_FAIL="CREATE_AGENT_FAIL";

export const UPDATE_AGENT_START="UPDATE_AGENT_START";
export const UPDATE_AGENT_SUCCESS="UPDATE_AGENT_SUCCESS";
export const UPDATE_AGENT_FAIL="UPDATE_AGENT_FAIL";

//agent detail
export const GET_AGENT_DETAIL_START="GET_AGENT_DETAIL_START";
export const GET_AGENT_DETAIL_SUCCESS="GET_AGENT_DETAIL_SUCCESS";
export const GET_AGENT_DETAIL_FAIL="GET_AGENT_DETAIL_FAIL";

export const UPDATE_AGENT_DETAIL_START="UPDATE_AGENT_DETAIL_START";
export const UPDATE_AGENT_DETAIL_SUCCESS="UPDATE_AGENT_DETAIL_SUCCESS";
export const UPDATE_AGENT_DETAIL_FAIL="UPDATE_AGENT_DETAIL_FAIL";

//agentProduct
export const ADD_AGENT_PRODUCT_START="ADD_AGENT_PRODUCT_START";
export const ADD_AGENT_PRODUCT_SUCCESS="ADD_AGENT_PRODUCT_SUCCESS";
export const ADD_AGENT_PRODUCT_FAIL="ADD_AGENT_PRODUCT_FAIL";

export const UPDATE_AGENT_PRODUCT_START="UPDATE_AGENT_PRODUCT_START";
export const UPDATE_AGENT_PRODUCT_SUCCESS="UPDATE_AGENT_PRODUCT_SUCCESS";
export const UPDATE_AGENT_PRODUCT_FAIL="UPDATE_AGENT_PRODUCT_FAIL";

//agent edit form
export const OPEN_AGENT_EDIT="OPEN_AGENT_EDIT";
export const CLOSE_AGENT_EDIT="CLOSE_AGENT_EDIT";

//agentProduct form

export const OPEN_AGENT_PRODUCT_ADD="OPEN_AGENT_PRODUCT_ADD";
export const CLOSE_AGENT_PRODUCT_ADD="CLOSE_AGENT_PRODUCT_ADD";

export const OPEN_AGENT_PRODUCT_EDIT="OPEN_AGENT_PRODUCT_EDIT";
export const CLOSE_AGENT_PRODUCT_EDIT="CLOSE_AGENT_PRODUCT_EDIT";

//agents in a product
export const GET_AGENTS_IN_PRODUCT_START="GET_AGENTS_IN_PRODUCT_START";
export const GET_AGENTS_IN_PRODUCT_SUCCESS="GET_AGENTS_IN_PRODUCT_SUCCESS";
export const GET_AGENTS_IN_PRODUCT_FAIL="GET_AGENTS_IN_PRODUCT_FAIL";

//create transaction
export const CREATE_TRANSACTION_START="CREATE_TRANSACTION_START";
export const CREATE_TRANSACTION_SUCCESS="CREATE_TRANSACTION_SUCCESS";
export const CREATE_TRANSACTION_FAIL="CREATE_TRANSACTION_FAIL";

//clear agents of selected product in transaction
export const CLEAR_AGENTS_IN_PRODUCT="CLEAR_AGENTS_IN_PRODUCT";

//Report

export const GET_REPORT_START="GET_REPORT_START";
export const GET_REPORT_SUCCESS="GET_REPORT_SUCCESS";
export const GET_REPORT_FAIL="GET_REPORT_FAIL";


//sms
export const SEND_SMS_START="SEND_SMS_START";
export const SEND_SMS_SUCCESS="SEND_SMS_SUCCESS";
export const SEND_SMS_FAIL="SEND_SMS_FAIL";

//statements
export const GET_STATEMENT_START="GET_STATEMENT_START";
export const GET_STATEMENT_SUCCESS="GET_STATEMENT_SUCCESS";
export const GET_STATEMENT_FAIL="GET_STATEMENT_FAIL";

//reportdetail
export const GET_REPORT_DETAIL_START="GET_REPORT_DETAIL_START";
export const GET_REPORT_DETAIL_SUCCESS="GET_REPORT_DETAIL_SUCCESS";
export const GET_REPORT_DETAIL_FAIL="GET_REPORT_DETAIL_FAIL";

//collector
export const COLLECTOR_TRANSACTION_START="COLLECTOR_TRANSACTION_START";
export const COLLECTOR_TRANSACTION_SUCCESS="COLLECTOR_TRANSACTION_SUCCESS";
export const COLLECTOR_TRANSACTION_FAIL="COLLECTOR_TRANSACTION_FAIL";

export const COLLECTOR_HISTORY_START="COLLECTOR_HISTORY_START";
export const COLLECTOR_HISTORY_SUCCESS="COLLECTOR_HISTORY_SUCCESS";
export const COLLECTOR_HISTORY_FAIL="COLLECTOR_HISTORY_FAIL";

//set last reported date
export const SET_LAST_REPORTED_DATE="SET_LAST_REPORTED_DATE";

//correction 
export const CORRECTION_START="CORRECTION_START";
export const CORRECTION_SUCCESS="CORRECTION_SUCCESS";
export const CORRECTION_FAIL="CORRECTION_FAIL";
